import { LocationType } from "../../../../../core/domain/models";
import { Mapper } from "../../../../../core/base";
import { LocationTypeWebEntity } from "./location-type-web-entity";

export class LocationTypeWebRepositoryMapper extends Mapper<LocationTypeWebEntity, LocationType> {
  mapFrom(param: LocationTypeWebEntity): LocationType {
    return {
      id: param.id,
      name: param.name    
    };
  }

  mapTo(param: LocationType): LocationTypeWebEntity {
    return {
        id: param.id,
        name: param.name    
      };
  }
}
